import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {saveAs} from 'file-saver/dist/FileSaver';
import { environment } from 'src/environments/environment';
declare var require: any
const FileSaver = require('file-saver');

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  encapsulation: ViewEncapsulation.None

}) export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scroll(0,0)
  }
//   downloadPdf()
//   {
//     this.http.get('https://s3.eu-west-2.amazonaws.com/dev.wellcareltd.co.uk/documents/application.pdf',{responseType:'arraybuffer'}).subscribe(pdf =>{
// const blob= new Blob([pdf],{ type: 'application/pdf' });
// const fileName='ApplicationForm.pdf';
// saveAs(blob,fileName);
//     },err =>{
//       console.log(err);
//     });

//   }
downloadPdf()
{
  // const pdfUrl = 'https://s3.eu-west-2.amazonaws.com/dev.wellcareltd.co.uk/documents/application.pdf';
   const pdfName ='application.pdf' ;
  var file = new Blob([environment.pdfUrl], { type: 'application/pdf' });
  var fileUrl = URL.createObjectURL(file);
  FileSaver.saveAs(environment.pdfUrl, pdfName);
}
downloadTimesheet(){
  // const pdfUrl = 'https://s3.eu-west-2.amazonaws.com/dev.wellcareltd.co.uk/documents/application.pdf';
  const pdfName ='wellcaretimesheet.pdf' ;
  var file = new Blob([environment.timesheetUrl], { type: 'application/pdf' });
  var fileUrl = URL.createObjectURL(file);
  FileSaver.saveAs(environment.timesheetUrl, pdfName);

}
}
